"use client";
import * as React from 'react';

import { AnalyticsContext, useAnalytics } from './contexts/AnalyticsContext';

type IAnalyticsProviderProps = {
  data: Record<string, any>;
};

export const AnalyticsProvider: React.FC<IAnalyticsProviderProps> = (props) => {
  const { data } = props;
  const higherLevelData = useAnalytics();

  return (
    <AnalyticsContext.Provider value={{ ...higherLevelData, ...data }}>
      {props.children}
    </AnalyticsContext.Provider>
  );
};
